import { useState, useEffect, useRef } from "react";
import { Box, Button, Card, IconButton, Typography, useMediaQuery, useTheme, Stack } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { styled } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import { setActiveMovieInfo } from "../../../store/home";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";

const Carousel = () => {
    /* Obtiene la función dispatch desde react-redux */
    const dispatch = useDispatch();

    const navigate = useNavigate();
    const { statusGetBillboard, slidesBillboard } = useSelector((state) => state.home);

    const [currentIndex, setCurrentIndex] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery("(max-width:1024px)"); // Verifica si la pantalla es móvil
    const transitionDuration = 500; // Duración de la transición en milisegundos
    const autoSlideInterval = 3000; // Intervalo para cambiar automáticamente de imagen
    const [isTransitioning, setIsTransitioning] = useState(false);
    const timeoutRef = useRef(null);
    const MoviesQuantity = slidesBillboard.length;

    useEffect(() => {
        /* Configura un temporizador para cambiar automáticamente de tarjeta */

        const handleAutoSlide = () => {
            handleNext();
        };

        timeoutRef.current = setInterval(handleAutoSlide, autoSlideInterval);

        return () => {
            /* Detiene el temporizador cuando el componente se desmonta */
            clearInterval(timeoutRef.current);
        };
    }, [currentIndex]);

    const handlePrev = () => {
        /* No permite cambiar a la tarjeta anterior si la aplicación está en transición */
        if (isTransitioning) return;
        setIsTransitioning(true);
        setTimeout(() => {
            /* Cambia a la tarjeta anterior */
            setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : slidesBillboard.length - 1));
            setIsTransitioning(false);
        }, transitionDuration);
    };

    const handleNext = () => {
        /* No permite cambiar a la tarjeta siguiente si la aplicación está en transición */
        if (isTransitioning) return;
        setIsTransitioning(true);
        setTimeout(() => {
            /* Cambia a la tarjeta siguiente */
            setCurrentIndex((prevIndex) => (prevIndex < slidesBillboard.length - 1 ? prevIndex + 1 : 0));
            setIsTransitioning(false);
        }, transitionDuration);
    };

    let visibleItems;

    let focusedItem;

    if (MoviesQuantity === 1) {
        visibleItems = isMobile ? [slidesBillboard[currentIndex]] : [slidesBillboard[currentIndex]];
        focusedItem = isMobile ? slidesBillboard[currentIndex] : slidesBillboard[currentIndex];
    } else if (MoviesQuantity < 5 && MoviesQuantity > 1) {
        visibleItems = isMobile ? [slidesBillboard[currentIndex]] : [slidesBillboard[(currentIndex - 1 + slidesBillboard.length) % slidesBillboard.length], slidesBillboard[currentIndex], slidesBillboard[(currentIndex + 1) % slidesBillboard.length]];
        focusedItem = isMobile ? slidesBillboard[currentIndex] : slidesBillboard[currentIndex];
    } else {
        visibleItems = isMobile ? [slidesBillboard[currentIndex]] : [slidesBillboard[(currentIndex - 1 + slidesBillboard.length) % slidesBillboard.length], slidesBillboard[currentIndex], slidesBillboard[(currentIndex + 1) % slidesBillboard.length], slidesBillboard[(currentIndex + 2) % slidesBillboard.length], slidesBillboard[(currentIndex + 3) % slidesBillboard.length]];
        focusedItem = isMobile ? slidesBillboard[currentIndex] : slidesBillboard[(currentIndex + 1) % slidesBillboard.length];
    }

    const CardBox = styled(Box)(({ theme }) => ({
        /* Establece el estilo para las tarjetas */
        flex: "0 0 auto",
        width: isMobile ? "100%" : "20%",
        margin: "0 10px",
        transition: "transform 0.5s, opacity 0.5s",
        marginTop: "20px", // Para bajar las tarjetas
    }));

    // const focusedItem = isMobile ? slidesBillboard[currentIndex] : slidesBillboard[(currentIndex + 1) % slidesBillboard.length];

    const getIdMovieInfo = (idMovie) => {
        /* Elimina la información de la película actual en el almacenamiento local */
        localStorage.removeItem("idLocalMovie");
        /* Establece la nueva película */
        localStorage.setItem("idLocalMovie", idMovie);
        /* Redirige a la página de la película */
        dispatch(setActiveMovieInfo(idMovie));
        navigate("/movie");
    };

    return (
        <Box style={{ height: "100%" }}>
            {/* <Typography
                variant="h4"
                align="center"
                gutterBottom
                style={{
                    position: "absolute",
                    fontSize: isMobile || isTablet? "30px" : "48px",
                    textTransform: "uppercase",
                    color: "#fff",
                    fontFamily: "FuturaP-ExtraBold",
                    marginTop: "3%",
                    marginLeft: isMobile ? "30%" : "7%",
                    
                }}
            >
                Cartelera
            </Typography> */}

            <NavLink
                to="/cartelera"
                style={{
                    position: "absolute",
                    fontSize: isMobile || isTablet? "30px" : "48px",
                    textTransform: "uppercase",
                    color: "#fff",
                    fontFamily: "FuturaP-ExtraBold",
                    marginTop: "3%",
                    marginLeft: isMobile ? "30%" : "7%",
                    textDecoration: "none",
                    zIndex: 100,
                    
                }}
                >
                Cartelera
                </NavLink>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    width: "100%",
                    padding: "37px 0",
                    justifyContent: "center",
                    overflow: "hidden", // Asegura que el efecto de desenfoque no se desborde
                    paddingTop: isMobile ? "15%" : "10%", // Para bajar el carrusel
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundImage: `url(${focusedItem.image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        filter: "blur(8px)",
                        zIndex: -1,
                    }}
                />
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#000",
                        opacity: 0.5,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        zIndex: -1,
                    }}
                />
                <IconButton onClick={handlePrev} sx={{ position: "absolute", left: 0, backgroundColor: "#000", width: "50px", height: "40px", borderRadius: "0px" }}>
                    <ArrowBackIosIcon style={{ color: "#fff" }} />
                </IconButton>
                <Box sx={{ display: "flex", overflow: "hidden", width: "80%", justifyContent: "center", height: "546px", marginTop: isTablet ? "3%" : "-1%" }}>
                    {visibleItems.map((item, index) => {
                        // const isFocused = isMobile ? index === 0 : index === 2; // En responsive, el foco está en el primer elemento; en escritorio, en el segundo
                        let isFocused;
                        if (MoviesQuantity < 5 && MoviesQuantity > 1) {
                            isFocused = isMobile ? index === 0 : index === 1;
                        } else if (MoviesQuantity === 1) {
                            isFocused = index === 0;
                        } else {
                            isFocused = isMobile ? index === 0 : index === 2;
                        }
                        return (
                            <CardBox
                                key={index}
                                sx={{
                                    transform: isFocused ? "scale(1.1)" : "scale(0.9)",
                                    opacity: isFocused ? 1 : 0.5,
                                    width: "246px",
                                    position: "relative",
                                    height: "552px",
                                }}
                            >
                                {item.type === "estreno" && (
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: "0",
                                            left: "0",
                                            backgroundColor: "#FFF504",
                                            color: "#102220",
                                            padding: "5px 10px",
                                            fontFamily: "FuturaP-ExtraBold",
                                            fontSize: "19px",
                                            textTransform: "uppercase",
                                            zIndex: 1,
                                            width: "92%",
                                            textAlign: "center",
                                        }}
                                    >
                                        Estreno
                                    </Box>
                                )}
                                <Card sx={{ maxWidth: 345, margin: "0 auto", backgroundColor: "transparent", boxShadow: "none" }}>
                                    <Stack direction="column" justifyContent="center" alignItems="center" spacing={0}>
                                        <img src={item.image} style={{ width: "246px", height: "352px", marginBottom:"30px" }} />
                                        <Typography
                                            variant="h5"
                                            component="div"
                                            style={{
                                                fontSize: "20px",
                                                textTransform: "uppercase",
                                                color: "#fff",
                                                fontFamily: "FuturaP-Bold",
                                                height: "45px",
                                                textAlign: "center",
                                                lineHeight: "1.2",
                                            }}
                                        >
                                            {item.title}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            style={{
                                                fontSize: "15px",
                                                textTransform: "uppercase",
                                                color: "#fff",
                                                fontFamily: "FuturaP-Light",
                                                fontWeight: "100",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            {item.subtitle}
                                        </Typography>
                                        <Button
                                            size="small"
                                            style={{
                                                fontSize: "15px",
                                                textTransform: "uppercase",
                                                color: "#fff",
                                                fontFamily: "FuturaP-Bold",
                                                backgroundColor: "#67BF47",
                                                borderRadius: "6px",
                                                boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                                                height: "40px",
                                            }}
                                            className="buttonCartelera"
                                            onClick={() => getIdMovieInfo(item.idMasterMovie)}
                                        >
                                            {item.buttonText}
                                        </Button>
                                    </Stack>
                                </Card>
                            </CardBox>
                        );
                    })}
                </Box>
                <IconButton onClick={handleNext} sx={{ position: "absolute", right: 0, backgroundColor: "#000", width: "50px", height: "40px", borderRadius: "0px" }}>
                    <ArrowForwardIosIcon style={{ color: "#fff" }} />
                </IconButton>
            </Box>
        </Box>
    );
};

export default Carousel;
